import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrls: ['./hotel.component.css']
})
export class HotelComponent implements OnInit {
  folder:string = "/assets/leroyal/"
  holder1:string
  holder2:string
  holder3:string
  holder4:string
  holder5:string
  holderBig:string
  position:number = 2;
  interval:any;
  slides:string[];
  
  hideSlide:boolean = true;
  constructor() { }

  ngOnInit() {
    
  	this.slides = [
  		this.folder+"slide1.jpg",
  		this.folder+"slide2.jpg",
  		this.folder+"slide3.jpg",
  		this.folder+"slide4.jpg",
  		this.folder+"slide5.jpg",
  		this.folder+"slide6.jpg",
  		this.folder+"slide7.jpg",
  		this.folder+"slide8.jpg",
  		this.folder+"slide9.jpg",
  		this.folder+"slide10.jpg",
  		this.folder+"slide11.jpg",
  		this.folder+"slide12.jpg",
  		this.folder+"slide13.jpg",
  		this.folder+"slide14.jpg",
  		this.folder+"slide15.jpg",
  		this.folder+"slide16.jpg",
  		this.folder+"slide17.jpg",
  		this.folder+"slide18.jpg",
  		this.folder+"slide19.jpg",
  		this.folder+"slide20.jpg",
  		this.folder+"slide21.jpg",
  		this.folder+"slide22.jpg",
  		this.folder+"slide23.jpg",
  		this.folder+"slide24.png",
  		this.folder+"slide25.jpg",
  		this.folder+"slide26.jpg",
  		this.folder+"slide27.jpg",
  		this.folder+"slide28.jpg",
  		this.folder+"slide29.jpg",
  		this.folder+"slide30.jpg",
  		this.folder+"slide31.jpg",
  		this.folder+"slide32.jpg",
  		this.folder+"slide33.jpg",
  		this.folder+"slide34.jpg",
  		this.folder+"slide35.jpg",
  		this.folder+"slide36.jpg",
  		this.folder+"slide37.jpg",
  		this.folder+"slide38.jpg"
  	]
    this.holder1 = this.slides[0]
    this.holder2 = this.slides[1]
    this.holder3 = this.slides[2]
    this.holder4 = this.slides[3]
    this.holder5 = this.slides[4]
    this.holderBig = this.holder3
  	this.interval = setInterval(() => {this.next()},3000)
  }
  next(){
  	this.setPosition(this.position+1)
  }
  prev(){
  	this.setPosition(this.position-1)
  }
  show(){
    this.hideSlide = false;
  }
  hide(){
    this.hideSlide = true;
  }
  setPosition(position:number){
  	this.position = position
  	if(this.position>this.slides.length-3)
  		this.position = 2
  	else if(this.position<1)
  		this.position = this.slides.length-3
  	this.holder1 = this.slides[this.position-2]
  	this.holder2 = this.slides[this.position-1]
  	this.holder3 = this.slides[this.position]
  	this.holder4 = this.slides[this.position+1]
  	this.holder5 = this.slides[this.position+2]
  }
}



// WEBPACK FOOTER //
// ./src/app/hotel/hotel.component.ts